import { Injectable } from '@angular/core';
import {GeneralService} from "../../../services/general-delete.service";
import {HttpClient} from "@angular/common/http";
import {StorageService} from "front-common-toolkits";
import {map, shareReplay} from "rxjs/operators";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class TenantService extends GeneralService {
  httpBase = environment.tenantHttpBase;
  constructor(
    public http: HttpClient,
    private storageService: StorageService
  ) {
    super(http);

    this.setModelPath('/ten/tenant');
  }

  getAccountInfo() {
    return this.http.get(this.httpBase + '/ten/auth/user').pipe(map(res => res['data']));
  }

  getTenantInfo() {
    return this.http.get(this.httpBase + '/ten/tenant').pipe(map(res => res['data']));
  }

  changeModuleUsers(params: any) {
    let api = this.httpBase + '/ten/tenant/changeModuleUsers'
    var data = params
    return this.http.post(api, data, { reportProgress: true, })
  }

  changeMac(mac: String) {
    let api = this.httpBase + '/ten/tenant/changeMac/'+mac;
    return this.http.put(api, {}, { reportProgress: true, })
  }

  changeOwner(userId: String) {
    let api = this.httpBase + '/ten/tenant/changeOwner/'+userId;
    return this.http.put(api, {}, { reportProgress: true, })
  }

  update() {
    let api = this.httpBase + '/ten/tenant/update';
    return this.http.post(api, {}, { reportProgress: true, })
  }
}
